import { createSelector } from 'reselect';
import {
    getAssetsLoadingStatus, getPowertrainLoadingStatusv2
} from 'helpers/selectors';
import { getSelectedNotification } from '../../PowertrainOverview/Header/NotificationDropdown/selectors';

export const getSelectedAsset = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedAsset;
};

export const getSelectedAssetV2 = ({ conditionIndices }) => {
    return conditionIndices?.assets;
};

export const getAssetCapabilityLoadingStatus = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedAssetCapability?.loadingStatus;
};

export const getNewCapabilityLoadingStatus = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.newAssetCapability?.loadingStatus;
};

export const getGeneralFilterLoadingStatuses = ({ generalFilter }) => {
    return {
        organizationsLoadingStatus: generalFilter?.organizations?.loadingStatus,
        sitesLoadingStatus: generalFilter?.sites?.loadingStatus,
        assetGroupsLoadingStatus: generalFilter?.assetGroups?.loadingStatus,
        contextLoadingStatus: generalFilter?.contextLoadingStatus
    };
};

export const getSitesCheckedFilters = ({ generalFilter }) => {
    return generalFilter?.selectedFilters?.sitesChecked;
};
// const getConditionInsightsStatus = ({ detailedInformation }) => {
//     return detailedInformation?.conditionInsightAssetStatus;
// };

export const getNameplatePicturesLoadingStatus = ({ assetDetailsInfoHeader }) => {
    return assetDetailsInfoHeader?.nameplatePictures?.loadingStatus;
};

export const getModel = createSelector([
    getSelectedAsset,
    getSelectedAssetV2,
    getAssetCapabilityLoadingStatus,
    getNewCapabilityLoadingStatus,
    getGeneralFilterLoadingStatuses,
    getSitesCheckedFilters,
    getAssetsLoadingStatus,
    getPowertrainLoadingStatusv2,
    // getConditionInsightsStatus
    getSelectedNotification,
    getNameplatePicturesLoadingStatus
],
    (
        asset,
        assetV2,
        capabilityLoadingStatus,
        newCapabilityLoadingStatus,
        generalFilterLoadingStatuses,
        sitesChecked,
        assetsLoadingStatus,
        powertrainsLoadingStatus,
        selectedNotification,
        nameplatePicturesLoadingStatus
    ) => {
        return {
            asset,
            assetV2,
            capabilityLoadingStatus,
            newCapabilityLoadingStatus,
            generalFilterLoadingStatuses,
            sitesChecked,
            assetsLoadingStatus,
            powertrainsLoadingStatus,
            selectedNotification,
            nameplatePicturesLoadingStatus
        };
    });
